module.exports = __webpack_public_path__ + "img/USD-CAD.740dea4d.png";